import { render, staticRenderFns } from "./DynamicMultipleChoiceModal.vue?vue&type=template&id=78984ce2&scoped=true"
import script from "./DynamicMultipleChoiceModal.vue?vue&type=script&lang=js"
export * from "./DynamicMultipleChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicMultipleChoiceModal.vue?vue&type=style&index=0&id=78984ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78984ce2",
  null
  
)

export default component.exports